import React, {useState} from 'react';
import {Button, message, Steps, theme} from 'antd';
import "./account-setup.scss"
import PersonalInfo from "./steps/PersonalInfo";

const steps = [
    {
        title: 'Personal Info',
        content: <PersonalInfo/>,
    },
    {
        title: 'Second',
        content: 'Second-content',
    },
    {
        title: 'Last',
        content: 'Last-content',
    },
];

const AccountSetup = () => {
    const { token } = theme.useToken();
    const [current, setCurrent] = useState(0);

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const items = steps.map((item) => ({ key: item.title, title: item.title }));



    return (
        <div className={'account-setup'}>
            <Steps current={current} items={items} labelPlacement="vertical"/>
            <div>{steps[current].content}</div>
            <div>
                {current < steps.length - 1 && (
                    <Button type="primary" onClick={() => next()}>
                        Next
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button type="primary" onClick={() => message.success('Processing complete!')}>
                        Done
                    </Button>
                )}
                {current > 0 && (
                    <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                        Previous
                    </Button>
                )}
            </div>
        </div>
    );
};

export default AccountSetup;